import * as React from "react";

import { Loader } from "@progress/kendo-react-indicators";
import { getter } from "@progress/kendo-react-common";

import { Toolbar, Button, ButtonGroup } from "@progress/kendo-react-buttons";
import {
    Grid,
    GridColumn,
    GridSelectionChangeEvent,
    getSelectedState,
} from "@progress/kendo-react-grid";
import { GroupDescriptor } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn, ExcelExportGroupHeaderProps } from '@progress/kendo-react-excel-export';
import { process } from "@progress/kendo-data-query";

import { useGetReportsQuery } from '../../store/sunbright-api';

export interface ExternalExamsGridProps {
    fromDate: string;
    toDate: string;
    returnLabel: string;
    onReturn?: any;
}

const DATA_ITEM_KEY = "uid";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const initialGroup: GroupDescriptor[] = [{ field: 'region' }];

const TextOnlyGroupHeader = (props: ExcelExportGroupHeaderProps) => {
    return `${props.value}`;
};

const ExternalExamsGrid = ({
    fromDate,
    toDate,
    returnLabel,
    onReturn,
}: ExternalExamsGridProps) => {
    const { data: report, error: reportError, isLoading: reportLoading } = useGetReportsQuery("external?from=" + fromDate + "&to=" + toDate);

    const [gridHeight, setGridHeight] = React.useState<string>("600px");
    const [excelData, setExcelData] = React.useState<any[]>([{}]);

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setGridHeight((window.innerHeight - 120) + "px");

        if (Array.isArray(report)) {
            setExcelData(process(report, { group: [{ field: "region" }] }).data)
        }
   }, [report]);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const [selectedUID, setSelectedUID] = React.useState<string>("");

    const handleSelectionChange = (e: GridSelectionChangeEvent) => {
        const newState = getSelectedState({
            event: e,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        })
        setSelectedState(newState);

        setSelectedUID(Object.keys(newState)[0]);
    };

    var _export = React.useRef<ExcelExport | null>(null);
    const excelExport = () => {
        if (_export.current !== null) {
            _export.current.save();
        }
    };

    return (
        <React.Fragment>
            <div>
                <Toolbar>
                    <Button
                        className="sds-buttoninbar"
                        icon="undo"
                        onClick={(e) => onReturn()}
                    >
                        {returnLabel}
                    </Button>
                    <div style={{ fontSize: "large", fontWeight: "bold", paddingLeft: "64px" }}>
                        External Exams {fromDate + " - " + toDate}
                    </div>
                </Toolbar>
                <div style={{ position: "fixed", top: "46px", right: "64px", zIndex: "99" }}>
                    <ButtonGroup>
                        <Button
                            themeColor={"primary"}
                            icon="file-report"
                            style={{ borderLeftColor: "white", borderLeftWidth: "1px" }}
                            onClick={excelExport}
                        >
                            Export to Excel
                        </Button>
                    </ButtonGroup>
                </div>

                {reportError ? (<>Not Authorized</>) : reportLoading ? <Loader size="large" type="converging-spinner" /> : report ?
                    (<div>
                        <ExcelExport
                            data={excelData}
                            fileName="ExternalExams.xlsx"
                            group={[{ field: 'region' }]}
                            collapsible={true}
                            ref={_export}
                        >
                            <ExcelExportColumn field="status" title="Status" width={80} />
                            <ExcelExportColumn field="updated" title="Updated" cellOptions={{format:"MMM d yyyy", textAlign: "left"}} width={95} />
                            <ExcelExportColumn field="value" title="Value" width={450} />
                            <ExcelExportColumn field="content" title="Content" width={450} />
                            <ExcelExportColumn field="id" title="ID" width={160} />
                            <ExcelExportColumn field="region" hidden={true} groupHeader={TextOnlyGroupHeader} />
                       </ExcelExport>
                        <Grid
                            style={{ height: gridHeight }}
                            className="eventSummaryGrid"
                            data={report.map((item: any) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)]
                            }))}

                            autoProcessData={true}
                            groupable={true}
                            defaultGroup={initialGroup}

                            resizable={true}
                            size={"small"}
                            dataItemKey={DATA_ITEM_KEY}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: true,
                                mode: "single",
                            }}
                            onSelectionChange={handleSelectionChange}
                        >
                            <GridColumn field="region" title="Region" width="0px"/>
                            <GridColumn field="status" title="Status" width="80px" />
                            <GridColumn field="updated" title="Updated" format="{0:MMM d yyyy}" width="95px" />
                            <GridColumn field="value" title="Value" width="338px" />
                            <GridColumn field="content" title="Content"/>
                            <GridColumn field="id" title="ID" width="160px" />
                        </Grid>
                    </div>) : null}
           </div>
        </React.Fragment>
    );
}
export default ExternalExamsGrid;